/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import React, { useState, useEffect } from "react";

//context
import { useOrdersValue, useProgressValue } from "../context";
//custom libraries

import {
  FORM_FIELD_ORDER_DATE_FROM,
  FORM_FIELD_ORDER_DATE_TO,
  FORM_FIELD_ORDER_ID,
  FORM_FIELD_PHONE,
} from "../constants/common";

import { useResendHandler } from "./rest/use-resend-handler";
import { ORDER_STATUS } from "../constants/order";

export interface ParamsJson {
  limit?: number;
  offset?: number;
  [FORM_FIELD_ORDER_ID]?: string;
  findBy?: string;
  logonId?: string;
  logonIdSearchType?: string;
  orderByTableName?: string;
  orderByFieldName?: string;
  firstName?: string;
  firstNameSearchType?: string;
  lastName?: string;
  lastNameSearchType?: string;
  streetAddress1?: string;
  streetAddress1SearchType?: string;
  city?: string;
  citySearchType?: string;
  zipCode?: string;
  zipCodeSearchType?: string;
  country?: string;
  countrySearchType?: string;
  state?: string;
  stateSearchType?: string;
  email?: string;
  emailSearchType?: string;
  [FORM_FIELD_PHONE]?: string;
  phoneSearchType?: string;
  [FORM_FIELD_ORDER_DATE_FROM]?: string;
  [FORM_FIELD_ORDER_DATE_TO]?: string;
  orderDateSearchType?: string;
  addressType?: string;
  parentOrgNameSearchType?: string;
  parentOrgName?: string;
  groupBy?: String;
}

export const initParams: ParamsJson = {
  [FORM_FIELD_ORDER_DATE_FROM]: "",
  [FORM_FIELD_ORDER_DATE_TO]: "",
  groupBy: "DATE",
};

export const useResendForm = () => {
  const [listRecords, setListRecords] = useState([]);
  const { setInProgress } = useProgressValue();
  const [showMessage, setShowMessage] = useState(false);
  const [chips, setChips] = React.useState<any>({});
  const [showForm, setShowForm] = React.useState<boolean>(true);
  const [isPaymentApproved, setIsPaymentApproved] = useState(false);

  const { resendXML, resendPaymentInfo } = useResendHandler();

  const submitResendForm = (evt: any) => {
    setInProgress(true);
    const [res, canceler] = resendXML(evt.orderNumber);

    return res
      .then((r) => r.data)
      .then((data) => {
        setShowMessage(true);
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setInProgress(false);
      });
  };

  const submitResendPaymentForm = (evt: any) => {
    setInProgress(true);
    const [res, canceler] = resendPaymentInfo(evt.orderNumber, evt);

    return res
      .then((r) => r.data)
      .then((data) => {
        if (data && data.orderStatus === ORDER_STATUS.PaymentApproved) {
          setIsPaymentApproved(true);
        }
        setShowMessage(true);
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setInProgress(false);
      });
  };

  const removeChip = (name: string) => {
    /*   const newParams = { ...params, [name]: "" };
    getSales(newParams, ZERO_OFFSET); */
    /*     setParams(newParams); */
  };

  useEffect(() => {
    console.log(showMessage);
  }, [showMessage]);

  return {
    /*     changeInput, */
    listRecords,
    submitResendForm,
    submitResendPaymentForm,
    removeChip,
    chips,

    showForm,
    setShowForm,

    showMessage,
    setShowMessage,

    isPaymentApproved,
    setIsPaymentApproved,
  };
};
